import React from 'react';

const Footer = () => {
    return (
        <footer className="d-flex justify-content-center" style={{backgroundColor: '#191919', padding: '50px'}}>
            <div className="col-md-8 d-flex flex-column">
                <div className="col-md-10">
                <img src={require('../../images/logo2.png').default} alt="" style={{width: '20%'}}/>
                </div>
                <div style={{cursor: 'pointer'}}><small style={{color: '#4A4A4A'}}>Copyright © Online food</small></div>
            </div>
            <div className="col-md-4" style={{color: "white", cursor: 'pointer'}}>
               <div className="d-flex">
               <div className="col-md-6">
                    <p>About Online Food</p>
                    <p>Read our blog</p>
                    <p>Sign up to deliver</p>
                    <p>Add your restaurant</p>
                </div>
                <div className="col-md-6">
                    <p>Get Help</p>
                    <p>Read FAQs</p>
                    <p>View all cities</p>
                    <p>Restaurants near me</p>
                </div>
               </div>
               <div className="d-flex" style={{marginTop: '40px'}}>
                   <p style={{marginRight: '30px', marginLeft: '100px'}}>Privacy Policy</p>
                   <p style={{marginRight: '30px'}}>Terms of Use</p>
                   <p style={{marginRight: '30px'}}>Pricing</p>
               </div>
               </div>
        </footer>
    );
};

export default Footer;